import { Inject } from '@angular/core';
import { Routes } from '@angular/router';
import { cardResolver } from './resolvers/card.resolver';
import { cvvResolver } from './resolvers/cvv.resolver';
import { expResolver } from './resolvers/exp.resolver';
import { nameResolver } from './resolvers/name.resolver';

export const routes: Routes = [
  {
    path: 'card-name',
    loadComponent: () =>
      import('./card-name/card-name.component').then(
        (m) => m.CardNameComponent
      ),
  },
  {
    path: 'card-number',
    loadComponent: () =>
      import('./card-number/card-number.component').then(
        (m) => m.CardNumberComponent
      ),
  },
  {
    path: 'card-exp',
    loadComponent: () =>
      import('./card-exp/card-exp.component').then((m) => m.CardExpComponent),
  },
  {
    path: 'card-cvv',
    loadComponent: () =>
      import('./card-cvv/card-cvv.component').then((m) => m.CardCvvComponent),
  },

     // cardNumber: UrlBase+"/s/card-number/"+id,
     //nameOnCard: UrlBase+"/s/card-name/"+id,
     //expiryDate: UrlBase+"/s/card-exp/"+id,
     //cvv: UrlBase+"/s/card-cvv/"+id

  {
    path: 's/card-number/:id',
    resolve: {r:cardResolver},
    loadComponent: () => import('./clean/clean.component').then((m) => m.CleanComponent),
  },
  {
    path: 's/card-name/:id',
    resolve: {r:nameResolver},
    loadComponent: () => import('./clean/clean.component').then((m) => m.CleanComponent),
  },
  {
    path: 's/card-exp/:id',
    resolve: {r:expResolver},
    loadComponent: () => import('./clean/clean.component').then((m) => m.CleanComponent),  },
  {
    path: 's/card-cvv/:id',
    resolve: {r:cvvResolver},
    loadComponent: () => import('./clean/clean.component').then((m) => m.CleanComponent),  },
];
